import React from "react";

const PaymentOption = ({
  amount,
  months,
  recommended,
  selected,
  onSelect,
  selectedIcon,
  unselectedIcon,
}) => {
  return (
    <div
      className={`flex items-center font-atkinson relative  max-w-[380px] w-full min-w-[280px] justify-between px-3 py-3 rounded-lg border-[1px] transition cursor-pointer
        ${
          selected
            ? "bg-[#DBEDFF] border-blue-500"
            : "bg-white border-[#B3B3B3]"
        }`}
      onClick={onSelect}
    >
      {recommended && (
        <div className="bg-[#CCF8E1] absolute -top-2.5 text-[#006F59] px-3 py-0.5 rounded-full text-[9px] font-medium border-[1px] border-[#12F280]">
          Recommended
        </div>
      )}

      <p className="text-[14px] font-medium">
        Pay ₹
        {Number(amount.toFixed(2)).toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}{" "}
        for {months} Months
      </p>
      <img
        src={selected ? selectedIcon : unselectedIcon}
        alt="select status"
        className="w-5 h-5"
      />
    </div>
  );
};

export default PaymentOption;
